import React, { Component } from "react";
import { SketchField, Tools } from "../../sketch";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { hotkeys } from "react-keyboard-shortcuts";
import {
  newKeyframe,
  updateKeyframe,
  setProjectType,
  undoKeyframe,
  deleteKeyframe,
  generateVideo,
  purgeCanvas,
  _handlePanTransform,
  removeNameAndID,
} from "../../redux/canvas/actions";

import {
  createNewProject,
  updateProject,
  getProjectDetailsById,
  loadExistingProjectFile,
} from "../../redux/user/actions";
import ColorPickerModal from "../../components/ColorPickerModal";
import UnsavedChangesModal from "../../components/UnsavedChangesModal";
import { hideLoader, showLoader } from "../../redux/app/actions";
import $ from "jquery";
import _ from "underscore";
import { swal } from "react-redux-sweetalert2";
import GIF from "gif.js.optimized";
import Whammy from "react-whammy";
import { saveAs } from "file-saver";
import Topbar from "./topbar";
import LeftTools from "./leftTools";
import RightTools from "./rightTools";
import { SketchPicker } from "react-color";
import Message from "../../utilities/messages";

import reactCSS from "reactcss";
const fabric = require("fabric").fabric;

const scaleFactor = 2;

class WiggleDoodle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTool: Tools.Pencil,
      canvasHeight: "",
      canvasWidth: "",
      sketchCanvas: {},
      keyframesLimit: 3,
      colorPick: false,
      pickCanvasColor: false,
      activeKeyframeIndex: 0,
      selectedBrushColor: "#300348",
      playing: false,
      traceEnabled: false,
      sendToBackEnabled: false,
      brushSize: 5,
      playingGif: "",
      isObjectSelected: false,
      pressureOpacity: 1,
      undoDisabled: false,
      isPasteEnabled: false,
      prompt: "",
      promptTowards: "",
      doubleClickedOnColorClass: "",
      blankProjectName: "",
      randomColorState: "",
      recentColors: [],
    };
    this.interval = "";
    this._gifCanvas = new fabric.Canvas(); // to create gif with white background
    this._imgSequence = new fabric.Canvas(); // to create image sequence
    this._imageCanvas = new fabric.Canvas(); // to set base64 while updating keyframe
    this._toVideoCanvas = new fabric.Canvas(); // canvas for video dowenload
    this.currentProject = {
      keyframes: [],
      projectType: "",
      lastDrawnAt: [],
    };
  }

  hot_keys = {
    del: {
      priority: 1,
      handler: (event) => this.removeSelectedObject(),
    },
    backspace: {
      priority: 1,
      handler: (event) => {
        if (this.state.isObjectSelected) this.removeSelectedObject();
        else console.log("cannot delete");
      },
    },
    "ctrl+z": {
      priority: 1,
      handler: (event) => {
        if (this.checkIfUndoIsDisabled()) this.undoAction();
        else console.log("cannot undo more..");
      },
    },
    "meta+z": {
      priority: 1,
      handler: (event) => {
        if (this.checkIfUndoIsDisabled()) this.undoAction();
        else console.log("cannot undo more..");
      },
    },
    "ctrl+c": {
      priority: 1,
      handler: (event) => {
        if (this.state.isObjectSelected) this.copy();
        else console.log("cannot copy as nothing is selected..");
      },
    },
    "meta+c": {
      priority: 1,
      handler: (event) => {
        if (this.state.isObjectSelected) this.copy();
        else console.log("cannot copy as nothing is selected..");
      },
    },
    "ctrl+x": {
      priority: 1,
      handler: (event) => {
        if (this.state.isObjectSelected) this.cut();
        else console.log("cannot cut as nothing is selected..");
      },
    },
    "meta+x": {
      priority: 1,
      handler: (event) => {
        if (this.state.isObjectSelected) this.cut();
        else console.log("cannot cut as nothing is selected..");
      },
    },
    "ctrl+v": {
      priority: 1,
      handler: (event) => {
        if (this.state.isPasteEnabled) this.paste();
        else console.log("cannot paste as nothing is copied..");
      },
    },
    "meta+v": {
      priority: 1,
      handler: (event) => {
        if (this.state.isPasteEnabled) this.paste();
        else console.log("cannot paste as nothing is copied..");
      },
    },
  };

  componentDidMount() {
    let context = this;
    context.interval = setInterval(() => {
      let width = context.drawing_board.clientWidth || 0;
      let height = context.drawing_board.clientHeight || 0;

      if (width > 0 && height > 0) {
        context.setState({
          canvasWidth: width,
          canvasHeight: height,
        });
        context._imageCanvas.setDimensions({
          width: width,
          height: height,
        });
        context._gifCanvas.setDimensions({
          width: width,
          height: height,
        });
        context._imgSequence.setDimensions({
          width: width,
          height: height,
        });
        context._toVideoCanvas.setDimensions({
          width: width,
          height: height,
        });
      }
    }, 1000);

    let { state } = this.props.history.location;
    if (state && state._id) {
      let projectDetailsObj = {
        _id: state._id,
        type: "wiggledoodle",
        fromProjectVault: state.fromProjectVault,
      };
      this.purgeCanvas();
      this.props.getProjectDetailsById(projectDetailsObj, (res) => {
        if (res.success) {
          this.setUp();
        }
      });
    } else {
      this.setUp();
    }
  }

  setUp() {
    let { keyframes } = this.props.canvas.currentProject;
    if (keyframes.length === 0) {
      let newKeyframeObj = {
        keyframeIndex: 0,
      };
      this.props.newKeyframe(newKeyframeObj);
    } else {
      let undoDisabled = keyframes.some((e) => {
        if (e.keyframe) {
          return e.keyframe.objects.length > 0;
        } else return false;
      });

      this.setState({
        sketchCanvas: keyframes[keyframes.length - 1].keyframe,
        activeKeyframeIndex: keyframes.length - 1,
        undoDisabled: undoDisabled,
      });
    }
    let setProjectTypeObj = {
      type: "wiggleDoodle",
    };

    var historyObj = {};

    keyframes.map((item, index) => {
      if (item.keyframe) {
        historyObj = {
          history: [
            {
              version: "3.2.0",
              objects: [],
            },
            item.keyframe,
          ],
          keyframe: item.keyframe,
          index: index,
        };
      } else {
        historyObj = {
          history: [
            {
              version: "3.2.0",
              objects: [],
            },
          ],
          keyframe: item.keyframe,
          index: index,
        };
      }

      this.currentProject.keyframes.push(historyObj);
      if (
        _.isEqual(
          this.currentProject.keyframes[0].history[0],
          this.currentProject.keyframes[0].history[1]
        )
      ) {
        this.currentProject.keyframes[0].history.splice(1, 1); // delete duplicate empty history object
      }
    });

    this.props.setProjectType(setProjectTypeObj);

    setTimeout(() => {
      this.setState({
        traceEnabled: true,
      });
    }, 1000);
  }

  componentDidUpdate(prevProps, prevState) {
    let { keyframes } = this.props.canvas.currentProject;
    let undoDisabled = keyframes.some((e) => {
      if (e.keyframe) {
        return e.keyframe.objects.length > 0;
      } else return false;
    });
    if (undoDisabled != this.state.undoDisabled)
      this.setState({
        undoDisabled: undoDisabled,
      });
    if (
      prevState.selectedTool == "circle" ||
      prevState.selectedTool == "triangle" ||
      prevState.selectedTool == "rectangle"
    ) {
      this.state.selectedTool = "select";
    }
  }

  // set tool to be used on drawing area
  setSelectedTool(val) {
    this.setState({
      selectedTool:
        val === "trace" && this.state.selectedTool === "trace" ? "pencil" : val,
      pickCanvasColor: false,
      selectedBrushColor: this.state.pickCanvasColor
        ? "rgba(48, 3, 72, 1)"
        : this.state.selectedBrushColor,
    });

    if (val == "pan") {
      this.setState({
        draggableIdActive: true,
      });
    } else {
      this.setState({
        draggableIdActive: false,
      });
    }
    this.sketchCanvas.deselectActiveObjects();
  }

  cut() {
    this.sketchCanvas.cut();
    this.updateSelectedKeyframe(
      "",
      this.state.activeKeyframeIndex,
      "fromCutFunction"
    );
  }

  copy() {
    this.sketchCanvas.copy();
  }

  paste() {
    let context = this;
    context.sketchCanvas.paste();
    this.updateSelectedKeyframe("", this.state.activeKeyframeIndex);
  }
  // set brush color to be used
  setBrushColor(className) {
    let choosen = this.state.selectedTool;
    let e = document.querySelector(`.${className}`);
    let computedStyle = getComputedStyle(e);

    let brushColorInRGB = computedStyle.getPropertyValue("background-color");
    let a = brushColorInRGB
      .substring(brushColorInRGB.indexOf("(") + 1, brushColorInRGB.indexOf(")"))
      .replace(/ /g, "");

    let b = a.split(",");
    let brushHexColor = this.rgbToHex(Number(b[0]), Number(b[1]), Number(b[2]));
    if (choosen != "eyedropper") {
      this.setState({
        selectedBrushColor: brushHexColor,
        randomColorState: Math.random(),
      });
    }
  }

  componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

  rgbToHex(r, g, b) {
    return (
      "#" +
      this.componentToHex(r) +
      this.componentToHex(g) +
      this.componentToHex(b)
    );
  }

  hexToRgb(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
      return r + r + g + g + b + b;
    });

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  }
  // handle color picker
  handleColorPicker(pickerSelectedColor) {
    let { doubleClickedOnColorClass } = this.state;
    $(`.${doubleClickedOnColorClass}`).css(
      "background-color",
      pickerSelectedColor
    );
    setTimeout(() => {
      this.setBrushColor(doubleClickedOnColorClass);
      $("[data-dismiss=modal]").trigger({ type: "click" });
    }, 300);
  }

  newColorPicker() {
    this.setState({ colorPick: !this.state.colorPick });
  }

  handleChangeComplete = (color) => {
    let hex_color = `rgba(${color.rgb.r},${color.rgb.g},${color.rgb.b},${color.rgb.a})`;

    this.setState((prevState) => {
      const recentColors = [...prevState.recentColors];

      // Remove the color if it already exists
      const colorIndex = recentColors.indexOf(hex_color);
      if (colorIndex > -1) {
        recentColors.splice(colorIndex, 1);
      }

      // Add the new color at the beginning of the list
      recentColors.unshift(hex_color);

      // Limit the recent colors list to 5 items
      if (recentColors.length > 8) {
        recentColors.pop();
      }

      return {
        selectedBrushColor: hex_color,
        recentColors: recentColors,
      };
    });
  };

  handleClose = () => {
    this.setState({ colorPick: false });
  };

  openColorPicker(classname) {
    $("#openColorPickerModal").trigger("click");
    setTimeout(() => {
      this.setState({
        doubleClickedOnColorClass: classname,
      });
    }, 300);
  }

  onPanStop(val) {
    this.props.dispatch(_handlePanTransform(val));
  }

  canvasColorPicker() {
    this.setState({
      pickCanvasColor: true,
      selectedTool: Tools.Eyedropper,
      selectedBrushColor: "#ffffff00",
    });
  }

  setCanvasColor(rgba) {
    if (rgba === "rgba(0,0,0,0)") {
      this.setState({
        pickCanvasColor: true,
        selectedTool: Tools.Eyedropper,
        selectedBrushColor: "#ffffff00",
      });
    } else {
      this.setState({
        pickCanvasColor: false,
        selectedTool: Tools.Pencil,
        selectedBrushColor: rgba,
      });
    }
  }

  // remove selected object or delete it from canvas
  removeSelectedObject() {
    let context = this;
    context.sketchCanvas.removeSelected();
    context.updateSelectedKeyframe(
      "",
      context.state.activeKeyframeIndex,
      "fromRemoveSelected"
    );
  }

  exportState() {
    let { keyframes, _id, name, isModified, panTransform } =
        this.props.canvas.currentProject,
      { userDetails } = this.props.user,
      { bgKeyframes } = this.props.canvas.bgTimeline;

    let saveObj = {
      data: JSON.stringify({
        keyframes,
        bgKeyframes,
        panTransform,
      }),
      // user: userDetails.id,
      // name: this.refs.projectName.value.trim(),
      category: "wiggledoodle",
    };

    let file = new Blob([btoa(JSON.stringify(saveObj, null, 2))], {
      type: "text/plain",
    });
    saveAs(file, "export-wiggledoodle.ish");
  }

  importState(file) {
    let result;
    try {
      // only emply in case of ish file
      document.getElementById("importImg").value = "";
      result = JSON.parse(atob(file));
      const { currentProject } = this.props.canvas;
      const { keyframes } = currentProject;
      const anyNewFrames =
        keyframes[0].keyframe && keyframes[0].keyframe.objects.length;
      let projectDetailsObj = {
        project: {
          data: result.data,
          _id: "",
          name: "",
        },
        isModified: true,
        type: result.category,
        redirect: false,
      };
      let userAlertResponse = new Promise((resolve, reject) => {
        if (result.category !== "wiggledoodle") {
          this.props.swal({
            title: "Info!",
            text: Message.import.redirect[result.category],
            type: "info",
            showConfirmButton: true,
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            confirmAlert: () => {
              projectDetailsObj.redirect = result.category.toLowerCase();
              resolve(true);
            },
            cancelCallback: () => resolve(false),
          });
        } else if (currentProject._id && currentProject.name) {
          this.props.swal({
            title: "Info!",
            text: Message.import.savedProjectOverwrite,
            type: "info",
            showConfirmButton: true,
            showCancelButton: true,
            showCloseButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No, Start a New Project",
            confirmAlert: () => {
              projectDetailsObj.project._id = currentProject._id;
              projectDetailsObj.project.name = currentProject.name;
              resolve(true);
            },
            cancelCallback: () => resolve(true),
          });
        } else if (currentProject.isModified && anyNewFrames) {
          this.props.swal({
            title: "Info!",
            text: Message.import.overwrite,
            type: "info",
            showConfirmButton: true,
            showCancelButton: true,
            showCloseButton: true,
            confirmAlert: () => resolve(true),
            cancelCallback: () => resolve(false),
          });
        } else {
          resolve(true);
        }
      });
      userAlertResponse.then((result) => {
        if (result) this.loadProjectFile(projectDetailsObj);
      });
    } catch (e) {
      this.props.swal({
        title: "Error",
        text: "Invalid File",
        type: "error",
        confirmAlert: () => false,
      });
    }
  }

  loadProjectFile(file) {
    this.purgeCanvas();
    this.props.loadExistingProjectFile(file, (err, res) => {
      if (file.redirect) {
        this.props.history.push("/" + file.redirect);
      } else if (res) {
        this.setUp();
      }
      // Incase of redirect move this to another component
      this.props.swal({
        title: "Success",
        text: Message.import.success,
        type: "success",
        confirmAlert: () => false,
      });
    });
  }

  // save video in the format specified
  saveVideo(type) {
    let { keyframes } = this.props.canvas.currentProject,
      context = this,
      loaderShown = false;
    context.encoder = new Whammy.Video();
    context.gif = new GIF({
      workers: 2,
      repeat: 0,
      quality: 10,
      height: context.state.canvasHeight * scaleFactor,
      width: context.state.canvasWidth * scaleFactor,
      workerScript: `${window.location.origin}/gif.worker.js`,
    });

    keyframes.map((item, index) => {
      if (item.keyframe && item.keyframe.objects.length > 0) {
        if (loaderShown == false) {
          context.props.showLoader();
          loaderShown = true;
        }
        context._gifCanvas.loadFromJSON(item.keyframe, () => {
          context._gifCanvas.backgroundColor = "white";
          var img = new Image();
          img.src = context._gifCanvas.toDataURL({ multiplier: scaleFactor });
          img.height = context.state.canvasHeight * scaleFactor;
          img.width = context.state.canvasWidth * scaleFactor;
          context.gif.addFrame(img, {
            delay: 150,
          });
        });
      }
    });

    context.gif.on("finished", function (blob) {
      context.props.hideLoader();
      var file = new File([blob], `${+new Date()}.gif`, {
        type: `image/gif`,
        lastModified: Date.now(),
      });

      let videoObj = {
        gif: file,
        format: type,
      };
      if (type !== "gif") {
        context.props.generateVideo(videoObj, (res) => {
          saveAs(res.filename);
          context.gif = null;
        });
      } else {
        saveAs(videoObj.gif, "download.gif");
      }
      // context.props.generateVideo(videoObj, (res) => {
      //   saveAs(res.filename);
      //   context.gif = null;
      // });
    });

    setTimeout(() => {
      let { options } = context.gif;
      if (options.height != null && options.width != null) context.gif.render();
    }, 1000);
  }

  saveAsImgSequence() {
    let { keyframes } = this.props.canvas.currentProject,
      context = this;
    keyframes.map((item, index) => {
      if (item.keyframe && item.keyframe.objects.length > 0) {
        context._imgSequence.loadFromJSON(item.keyframe, () => {
          context._imgSequence.backgroundColor = "white";
          context._imgSequence.renderAll();
          saveAs(
            context._imgSequence.toDataURL({ multiplier: scaleFactor }),
            "download.png"
          );
        });
      }
    });
  }

  // play animation in gif format
  playAnimation(type) {
    let { keyframes } = this.props.canvas.currentProject,
      context = this;
    context.props.showLoader();
    context.setState({
      playing: true,
    });
    context.gif = new GIF({
      workers: 2,
      repeat: 0,
      quality: 10,
      workerScript: `${window.location.origin}/gif.worker.js`,
    });

    keyframes.map((item, index) => {
      if (item.keyframe && item.keyframe.objects.length > 0)
        context._gifCanvas.loadFromJSON(item.keyframe, () => {
          context._gifCanvas.backgroundColor = "white";
          var img = new Image();
          img.src = context._gifCanvas.toDataURL();
          img.height = context.state.canvasHeight;
          img.width = context.state.canvasWidth;
          context.gif.addFrame(img, {
            delay: 150,
          });
        });
    });

    context.gif.on("finished", function (blob) {
      context.props.hideLoader();
      context.setState({
        playingGif: URL.createObjectURL(blob),
        traceEnabled: false,
      });
    });

    setTimeout(() => {
      context.gif.render();
    }, 1000);
  }

  // stop gif animation created
  stopAnimation() {
    this.gif = null;
    let { keyframes } = this.props.canvas.currentProject;

    this.setState({
      playingGif: "",
      playing: false,
      sketchCanvas: keyframes[keyframes.length - 1].keyframe,
      activeKeyframeIndex: keyframes.length - 1,
      traceEnabled: true,
    });
  }

  // save keyframe in redux on first render and when there is no next keyframe available
  saveKeyframe() {
    let { activeKeyframeIndex } = this.state;

    let newKeyframeObj = {
      keyframeIndex: activeKeyframeIndex + 1,
      saveBlankHistoryObj: true,
    };
    this.props.newKeyframe(newKeyframeObj);
    var historyObj = {
      history: [
        {
          version: "3.2.0",
          objects: [],
        },
      ],
    };
    this.currentProject.keyframes.push(historyObj);
    this.sketchCanvas.clear();

    this.setState({
      activeKeyframeIndex: activeKeyframeIndex + 1,
      traceEnabled: true,
    });
  }

  updateSelectedKeyframe(e, activeKeyframeIndex, fromWhere = "") {
    let currentJSONCanvas = this.sketchCanvas.toJSON(),
      { keyframes } = this.currentProject,
      context = this;

    let currentBlank = _.isEqual(currentJSONCanvas, {
      version: "3.2.0",
      objects: [],
    });
    let alreadyExist =
      keyframes[activeKeyframeIndex] &&
      keyframes[activeKeyframeIndex].hasOwnProperty("history") &&
      keyframes[activeKeyframeIndex].history.some((item) => {
        return _.isEqual(item, { version: "3.2.0", objects: [] });
      });
    let blankAlreadyExists;
    if (fromWhere === "fromRemoveSelected" || fromWhere === "fromCutFunction") {
      blankAlreadyExists = false;
    } else {
      blankAlreadyExists = currentBlank && alreadyExist;
    }
    if (
      (keyframes[activeKeyframeIndex] &&
        _.isEqual(
          currentJSONCanvas,
          keyframes[activeKeyframeIndex].keyframe
        )) ||
      blankAlreadyExists
    ) {
    } else {
      let updateKeyframeObj = {
        keyframe: context.sketchCanvas.toJSON(),
        index: activeKeyframeIndex,
        // keyframesBase64: context.sketchCanvas.toDataURL()
      };
      context._imageCanvas.loadFromJSON(currentJSONCanvas, (e) => {
        updateKeyframeObj.keyframesBase64 = context._imageCanvas.toDataURL();
        context.props.updateKeyframe(updateKeyframeObj);
        if (this.currentProject.keyframes[activeKeyframeIndex]) {
          /******** keep history and current keyframe in component level variable *********/
          this.currentProject.keyframes[activeKeyframeIndex].keyframe =
            context.sketchCanvas.toJSON();

          this.currentProject.lastDrawnAt = [
            ...this.currentProject.lastDrawnAt,
            {
              index: activeKeyframeIndex,
              history: context.sketchCanvas.toJSON().objects.length,
            },
          ];

          this.currentProject.keyframes[activeKeyframeIndex].history = [
            ...this.currentProject.keyframes[activeKeyframeIndex].history,
            context.sketchCanvas.toJSON(),
          ];
          /******** keep history and current keyframe in component level variable *********/
        }
        context.setState({
          // sketchCanvas: context.sketchCanvas.toJSON(),
          undoDisabled: true,
        });
      });
    }
  }

  undoFromCurrentProject(index, status = "") {
    let context = this,
      lastHistoryIndex =
        context.currentProject.keyframes[index].history.length - 1; // last index from history object of a selected keyframe

    if (status != "keyframeDeleted") {
      context.currentProject.keyframes[index].history = [
        ...context.currentProject.keyframes[index].history.slice(0, -1),
      ]; // removed last object from history
    }

    context.currentProject.lastDrawnAt = [
      ...context.currentProject.lastDrawnAt.slice(0, -1),
    ];

    let setFromHistory =
      context.currentProject.keyframes[index].history[
        context.currentProject.keyframes[index].history.length - 1
      ]; // object which will be used to set the current keyframe from history

    context.currentProject.keyframes[index].keyframe = setFromHistory;

    let updateKeyframeObj = {
      keyframe: setFromHistory,
      index: index,
    };
    // context.props.updateKeyframe(updateKeyframeObj);

    context._imageCanvas.loadFromJSON(setFromHistory, (e) => {
      updateKeyframeObj.keyframesBase64 = context._imageCanvas.toDataURL();
      context.props.updateKeyframe(updateKeyframeObj);
    });
  }

  undoAction() {
    // let lastCanvasIndex = this.currentProject.keyframes.length - 1;

    let lastCanvasIndex =
        this.currentProject.lastDrawnAt[
          this.currentProject.lastDrawnAt.length - 1
        ].index,
      noOfItemsInHistory =
        this.currentProject.lastDrawnAt[
          this.currentProject.lastDrawnAt.length - 1
        ].history;
    let context = this,
      { playing } = this.state;

    if (context.currentProject.keyframes[lastCanvasIndex].history.length >= 1) {
      let { keyframes } = context.currentProject;
      if (
        noOfItemsInHistory == 1 &&
        context.currentProject.keyframes.length != 1 &&
        context.currentProject.keyframes[0].history.length != 2
      ) {
        let deleteKeyframeObj = {
          index: lastCanvasIndex,
        };

        context.currentProject.keyframes.splice(lastCanvasIndex, 1); // delete keyrframe
        context.props.deleteKeyframe(deleteKeyframeObj);

        this.undoFromCurrentProject(lastCanvasIndex - 1, "keyframeDeleted");

        // context.setState(
        //   {
        //     sketchCanvas: keyframes[lastCanvasIndex - 1].keyframe,
        //     activeKeyframeIndex: lastCanvasIndex - 1,
        //   },
        //   () => {
        //     // context.updateSelectedKeyframe("e", lastCanvasIndex - 1, true);
        //   }
        // );

        context._imgSequence.loadFromJSON(
          keyframes[lastCanvasIndex - 1].keyframe,
          () => {
            context.setState(
              {
                sketchCanvas: context._imgSequence.toJSON(),
                activeKeyframeIndex: lastCanvasIndex - 1,
              },
              () => {
                // context.updateSelectedKeyframe("e", lastCanvasIndex - 1, true);
              }
            );
          }
        );
      } else {
        this.undoFromCurrentProject(lastCanvasIndex);
        // this.sketchCanvas.clear();
        context._imgSequence.loadFromJSON(
          keyframes[lastCanvasIndex].keyframe,
          () => {
            context.setState(
              {
                sketchCanvas: context._imgSequence.toJSON(),
                activeKeyframeIndex: lastCanvasIndex,
              },
              () => {
                // context.updateSelectedKeyframe("e", lastCanvasIndex, true);
              }
            );
          }
        );
      }
    }

    let { keyframes } = context.currentProject;
    if (
      keyframes.length - 1 === 0 &&
      keyframes[0].history &&
      keyframes[0].history.length === 1 &&
      keyframes[0].history[0].keyframe &&
      keyframes[0].history[0].keyframe.objects.length === 0
    )
      context.setState({
        undoDisabled: false,
      });

    if (playing) {
      this.stopAnimation();
    }
  }

  nextPressed() {
    let { keyframes } = this.props.canvas.currentProject;
    let { keyframesLimit, activeKeyframeIndex } = this.state;
    if (keyframes.length === keyframesLimit && activeKeyframeIndex === 2) {
      alert("3 keyframes already added! Cannot add more!");
      return;
    } else {
      if (activeKeyframeIndex === keyframes.length - 1) {
        this.saveKeyframe();
      } else {
        let keyframeToBeDrawn = keyframes[activeKeyframeIndex + 1].keyframe
          ? keyframes[activeKeyframeIndex + 1].keyframe
          : "";

        if (keyframeToBeDrawn === "") {
          this.sketchCanvas.clear();
        }
        this.setState(
          {
            sketchCanvas: keyframeToBeDrawn,
            activeKeyframeIndex: activeKeyframeIndex + 1,
          },
          () => {}
        );
      }
    }
  }

  backBtnActiveInactive() {
    let { activeKeyframeIndex } = this.state;
    if (activeKeyframeIndex === 0) return false;
    else return true;
  }

  prevPressed() {
    let { keyframes } = this.props.canvas.currentProject;
    let { activeKeyframeIndex } = this.state;
    if (activeKeyframeIndex === 0) {
      return;
    } else {
      this.setState(
        {
          sketchCanvas: keyframes[activeKeyframeIndex - 1].keyframe,
          activeKeyframeIndex: activeKeyframeIndex - 1,
        },
        () => {}
      );
    }
  }

  nextBtnActiveInactive() {
    let { keyframes } = this.currentProject;
    let { activeKeyframeIndex, playing } = this.state;
    let haveObjectsInKeyframe =
      keyframes.length > 0 &&
      keyframes[activeKeyframeIndex] &&
      keyframes[activeKeyframeIndex].hasOwnProperty("keyframe") &&
      keyframes[activeKeyframeIndex].hasOwnProperty("history") &&
      keyframes[activeKeyframeIndex].history.length > 1;
    if (activeKeyframeIndex === 2 || !haveObjectsInKeyframe || playing) {
      return false;
    } else {
      return true;
    } // return false
  }

  checkIfUndoIsDisabled() {
    let { lastDrawnAt } = this.currentProject;
    if (lastDrawnAt.length > 0) {
      return true;
    }
    return false;
  }

  checkIfObjectIsSelected(status) {
    let { isObjectSelected } = this.state;
    if (!status) {
      if (isObjectSelected) {
        this.setState({
          isObjectSelected: false,
        });
      }
    } else {
      if (!isObjectSelected) {
        this.setState({
          isObjectSelected: true,
        });
      }
    }
  }

  checkIfPlayButtonIsEnabled() {
    let context = this,
      { keyframes } = context.currentProject,
      { activeKeyframeIndex } = context.state;

    let playEnabled =
      activeKeyframeIndex === 2 &&
      keyframes[0] &&
      keyframes[0].hasOwnProperty("history") &&
      keyframes[0].history.length > 0 &&
      keyframes[1] &&
      keyframes[1].hasOwnProperty("history") &&
      keyframes[1].history.length > 0;

    if (playEnabled) {
      return true;
    }
    return false;
  }

  importImg(e) {
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      if (file.type && !file.name.endsWith(".txt")) {
        this.setState({ import_img: true });
        this.sketchCanvas.addImg(reader.result);
      } else {
        this.importState(reader.result);
      }
    };
    if (file && file.name.endsWith(".txt")) reader.readAsText(file);
    else if (file && file.type) reader.readAsDataURL(file);
    else if (
      file.name.substr(file.name.lastIndexOf("\\") + 1).split(".")[1] == "ish"
    )
      reader.readAsText(file);
  }

  newProjectOrGoToHomeOrFlipbook(type) {
    let { keyframes } = this.currentProject,
      { isModified, _id, name } = this.props.canvas.currentProject;
    let shallAsk = keyframes.some((e) => {
      if (e.keyframe) {
        return e.keyframe.objects.length > 0 && e.history.length > 1;
      } else return false;
    });
    if (shallAsk && isModified) {
      this.setState({
        prompt: "alertBox",
        promptTowards: type,
      });
      // this.props.swal({
      //   title: "You have unsaved changes!",
      //   text: "Do you want to save the current project before proceeding?",
      //   type: "warning",
      //   showConfirmButton: true,
      //   showCancelButton: true,
      //   confirmButtonText: "Yes, Save!",
      //   cancelButtonText: "Don't Save & Proceed!",
      //   confirmButtonColor: "green",
      //   showCloseButton: true,
      //   confirmAlert: () => {
      //     if (!_id && !name) {
      //       $("#openModal").trigger("click");
      //       this.setState({
      //         prompt: "alertBox",
      //         promptTowards: type
      //       });
      //     } else {
      //       this.saveOrUpdateProject("alertBox", type);
      //     }
      //   },
      //   cancelCallback: () => {
      //     if (type === "goToFlipbook") {
      //       this.props.history.push("/flipbook");
      //       this.props.dispatch(removeNameAndID());
      //     } else {
      //       this.purgeCanvas();
      //       setTimeout(() => {
      //         if (type === "goToHome") {
      //           this.props.history.push("/dashboard");
      //         } else if (type === "openIcon") {
      //           this.purgeCanvas();
      //           this.props.history.push("/project-vault");
      //         } else window.location.reload();
      //       }, 500);
      //     }
      //   }
      // });
      $("#unsavedChanges").trigger("click");
    } else {
      if (type === "goToFlipbook") {
        this.props.history.push("/flipbook");
        // this.props.purgeCanvas();
        // this.props.dispatch(removeNameAndID());
      } else {
        this.purgeCanvas();
        setTimeout(() => {
          if (type === "goToHome") {
            this.props.history.push("/dashboard");
          } else if (type === "openIcon") {
            this.purgeCanvas();
            this.props.history.push("/my-projects");
          } else window.location.reload();
        }, 500);
      }
    }
  }

  changeBrushSize(e) {
    this.setState({
      brushSize: Number(e.target.value) < 2 ? 1 : Number(e.target.value) / 5,
    });
  }

  enableDisableSendToBack(sendToBackEnabled) {
    this.setState({
      sendToBackEnabled: sendToBackEnabled,
    });
  }

  enableDisableTrace(traceEnabled) {
    this.setState({
      traceEnabled: traceEnabled,
    });
  }

  setPressureOpacity(e) {
    this.setState({
      pressureOpacity: Number(e.target.value),
    });
  }

  checkIfPasteIsEnabled(status) {
    this.setState({
      isPasteEnabled: status,
    });
  }

  saveFromModal(e) {
    e.preventDefault();
    let { prompt, promptTowards } = this.state;
    if (this.refs.projectName.value.trim() !== "") {
      $("[data-dismiss=modal]").trigger({ type: "click" });
      const modalElement = document.getElementById('save_modal');
      modalElement.classList.remove('in');
      modalElement.setAttribute('aria-hidden', 'true');
      modalElement.style.display = 'none';
      document.querySelector('.modal-backdrop').remove();
      
      if (prompt === "alertBox") {
        this.saveOrUpdateProject("alertBox", promptTowards);
      } else {
        this.saveOrUpdateProject();
      }
    } else {
      this.setState({
        blankProjectName: "* This is a required field.",
      });
    }
  }

  saveOrUpdateProjectFromSaveIcon() {
    let shallAsk = this.currentProject.keyframes.some((e) => {
        if (e.keyframe) {
          return e.keyframe.objects.length > 0 && e.history.length > 1;
        } else return false;
      }),
      { _id, name, isModified } = this.props.canvas.currentProject;
    if (shallAsk && isModified) {
      if (_id && name) {
        this.saveOrUpdateProject();
      } else {
        $("#openModal").trigger("click");
      }
    }
  }

  saveOrUpdateProject(calledFrom = "", type = "") {
    let shallAsk = this.currentProject.keyframes.some((e) => {
        if (e.keyframe) {
          return e.keyframe.objects.length > 0 && e.history.length > 1;
        } else return false;
      }),
      { keyframes, _id, name, isModified } = this.props.canvas.currentProject,
      { userDetails } = this.props.user;
    if (shallAsk && isModified) {
      if (_id && name) {
        let updateObj = {
          _id,
          data: JSON.stringify(keyframes),
        };
        this.props.updateProject(updateObj, (res) => {
          if (res.success) {
            if (calledFrom == "alertBox") {
              if (type !== "goToFlipbook") this.purgeCanvas();
              setTimeout(() => {
                if (type === "goToHome") {
                  this.props.history.push("/dashboard");
                } else if (type === "goToFlipbook") {
                  this.props.dispatch(removeNameAndID());
                  this.props.history.push("/flipbook");
                } else if (type === "openIcon") {
                  this.purgeCanvas();
                  this.props.history.push("/project-vault");
                } else window.location.reload();
              }, 500);
            }
          }
        });
      } else {
        let saveObj = {
          data: JSON.stringify(keyframes),
          user: userDetails.id,
          name: this.refs.projectName.value.trim(),
          category: "wiggledoodle",
        };
        this.props.createNewProject(saveObj, (res) => {
          if (res.success) {
            if (calledFrom == "alertBox") {
              if (type !== "goToFlipbook") this.purgeCanvas();
              setTimeout(() => {
                if (type === "goToHome") {
                  this.props.history.push("/dashboard");
                } else if (type === "goToFlipbook") {
                  this.props.history.push("/flipbook");
                  this.props.dispatch(removeNameAndID());
                } else if (type === "openIcon") {
                  this.purgeCanvas();
                  this.props.history.push("/project-vault");
                } else window.location.reload();
              }, 500);
            }
          }
        });

        this.refs.projectName.value = "";
      }
    }

    this.setState({
      prompt: "",
      promptTowards: "",
    });
  }

  purgeCanvas() {
    this.props.history.replace("/wiggledoodle", null);
    this.props.purgeCanvas();
  }

  openProjectsVault() {
    this.newProjectOrGoToHomeOrFlipbook("openIcon");
  }

  saveBtnInUnsavedChangesModal() {
    let { promptTowards } = this.state;
    let { isModified, _id, name } = this.props.canvas.currentProject;
    $("[data-dismiss=modal]").trigger({ type: "click" });
    if (!_id && !name) {
      setTimeout(() => {
        $("#openModal").trigger("click");
      }, 200);
    } else {
      this.saveOrUpdateProject("alertBox", promptTowards);
    }
  }

  noAndProceedBtn() {
    $("[data-dismiss=modal]").trigger({ type: "click" });
    let { promptTowards } = this.state;
    if (promptTowards === "goToFlipbook") {
      this.props.history.push("/flipbook");
      // this.props.purgeCanvas();
      // this.props.dispatch(removeNameAndID());
    } else {
      this.purgeCanvas();

      if (promptTowards === "goToHome") {
        this.props.history.push("/dashboard");
      } else if (promptTowards === "openIcon") {
        this.purgeCanvas();
        this.props.history.push("/project-vault");
      } else window.location.reload();
    }
  }

  render() {
    const styles = reactCSS({
      default: {
        popover: {
          position: "absolute",
          zIndex: "2",
        },
        cover: {
          position: "fixed",
          top: "0px",
          right: "0px",
          bottom: "0px",
          left: "0px",
        },
      },
    });
    let {
      selectedTool,
      activeKeyframeIndex,
      playing,
      traceEnabled,
      sendToBackEnabled,
      brushSize,
      selectedBrushColor,
      isObjectSelected,
      canvasWidth,
      canvasHeight,
      pressureOpacity,
      isPasteEnabled,
    } = this.state;
    let { keyframes } = this.props.canvas.currentProject;
    if (canvasHeight > 0 && canvasWidth > 0) {
      clearInterval(this.interval);
    }

    return (
      <div className="body_wrap">
        <div className="conta_iner">
          <div className="animation_ish_box advanced_outer_box wiggle_outer_div">
            <Topbar
              newProjectOrGoToHomeOrFlipbook={this.newProjectOrGoToHomeOrFlipbook.bind(
                this
              )}
              saveVideo={this.saveVideo.bind(this)}
              exportState={this.exportState.bind(this)}
              undoAction={this.undoAction.bind(this)}
              loadProjectFile={this.loadProjectFile.bind(this)}
              removeSelectedObject={this.removeSelectedObject.bind(this)}
              enableDisableSendToBack={this.enableDisableSendToBack.bind(this)}
              sendToBackEnabled={sendToBackEnabled}
              enableDisableTrace={this.enableDisableTrace.bind(this)}
              traceEnabled={traceEnabled}
              importImg={this.importImg.bind(this)}
              checkIfUndoIsDisabled={this.checkIfUndoIsDisabled.bind(this)}
              isObjectSelected={isObjectSelected}
              saveAsImgSequence={this.saveAsImgSequence.bind(this)}
              setPressureOpacity={this.setPressureOpacity.bind(this)}
              pressureOpacity={pressureOpacity}
              selectedBrushColor={selectedBrushColor}
              saveOrUpdateProjectFromSaveIcon={this.saveOrUpdateProjectFromSaveIcon.bind(
                this
              )}
              checkIfPasteIsEnabled={this.checkIfPasteIsEnabled.bind(this)}
              isPasteEnabled={isPasteEnabled}
              copy={this.copy.bind(this)}
              paste={this.paste.bind(this)}
              cut={this.cut.bind(this)}
              history={this.props.history}
              openProjectsVault={this.openProjectsVault.bind(this)}
            />

            <div className="tabLandscapeLayout">
              <div className="wiggle_doddle_main_mid_sec row">
                <LeftTools
                  selectedTool={selectedTool}
                  checkIfUndoIsDisabled={this.checkIfUndoIsDisabled.bind(this)}
                  undoAction={this.undoAction.bind(this)}
                  setSelectedTool={this.setSelectedTool.bind(this)}
                />
                <div className="wiggle_doddle_main_mid_center col-sm-8">
                  <div className="doddle_board_and_text">
                    <div className="make_doddle_text">
                      <img
                        src={
                          playing
                            ? "https://animationish-staging-images.s3.amazonaws.com/wiggle_doddle_main/trace_again.png"
                            : activeKeyframeIndex === 0
                            ? "https://animationish-staging-images.s3.amazonaws.com/wiggle_doddle_main/heading_text.png"
                            : activeKeyframeIndex === 1
                            ? "https://animationish-staging-images.s3.amazonaws.com/wiggle_doddle_main/now_trace_it.png"
                            : "https://animationish-staging-images.s3.amazonaws.com/wiggle_doddle_main/trace_again.png"
                        }
                      />
                    </div>
                    <div className="bg_img">
                      <div
                        className="make_drawing_board"
                        style={
                          playing
                            ? { pointerEvents: "none", userSelect: "none" }
                            : {}
                        }
                      >
                        <div
                          className="drawing_board"
                          id="drawing_board"
                          ref={(drawing_board) =>
                            (this.drawing_board = drawing_board)
                          }
                        >
                          {this.state.canvasHeight != 0 &&
                            !this.state.playingGif && (
                              <SketchField
                                ref={(sketchDraw) =>
                                  (this.sketchCanvas = sketchDraw)
                                }
                                height={this.state.canvasHeight}
                                width={this.state.canvasWidth}
                                tool={this.state.selectedTool}
                                traceEnabled={this.state.traceEnabled}
                                sendToBackEnabled={sendToBackEnabled}
                                lineColor={this.state.selectedBrushColor}
                                lineWidth={this.state.brushSize}
                                value={this.state.sketchCanvas}
                                opacity={pressureOpacity}
                                rgbToHex={this.rgbToHex.bind(this)}
                                hexToRgb={this.hexToRgb.bind(this)}
                                onPanStop={this.onPanStop.bind(this)}
                                setCanvasColor={this.setCanvasColor.bind(this)}
                                pickCanvasColor={this.state.pickCanvasColor}
                                keyframes={
                                  this.props.canvas.currentProject.keyframes
                                }
                                bgKeyframes={
                                  this.props.canvas.bgTimeline.bgKeyframes
                                }
                                activeKeyframeIndex={activeKeyframeIndex}
                                checkIfObjectIsSelected={this.checkIfObjectIsSelected.bind(
                                  this
                                )}
                                checkIfPasteIsEnabled={this.checkIfPasteIsEnabled.bind(
                                  this
                                )}
                                randomColorState={this.state.randomColorState}
                                onChange={
                                  playing
                                    ? (e) => {}
                                    : (e) =>
                                        this.updateSelectedKeyframe(
                                          e,
                                          activeKeyframeIndex
                                        )
                                }
                              />
                            )}

                          {playing && <img src={this.state.playingGif} />}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {
                  <div>
                    {this.state.colorPick ? (
                      <div style={styles.popover}>
                        <div style={styles.cover} onClick={this.handleClose} />
                        <SketchPicker
                          color={this.state.selectedBrushColor}
                          onChangeComplete={this.handleChangeComplete}
                          presetColors={this.state.recentColors}
                        />
                      </div>
                    ) : null}
                  </div>
                }

                <RightTools
                  setBrushColor={this.setBrushColor.bind(this)}
                  openColorPicker={this.openColorPicker.bind(this)}
                  brushSize={brushSize}
                  newColorPicker={this.newColorPicker.bind(this)}
                  selectedBrushColor={selectedBrushColor}
                  changeBrushSize={this.changeBrushSize.bind(this)}
                  backBtnActiveInactive={this.backBtnActiveInactive.bind(this)}
                  prevPressed={this.prevPressed.bind(this)}
                  nextPressed={this.nextPressed.bind(this)}
                  playAnimation={this.playAnimation.bind(this)}
                  keyframes={keyframes}
                  activeKeyframeIndex={activeKeyframeIndex}
                  stopAnimation={this.stopAnimation.bind(this)}
                  nextBtnActiveInactive={this.nextBtnActiveInactive.bind(this)}
                  playing={playing}
                  checkIfPlayButtonIsEnabled={this.checkIfPlayButtonIsEnabled.bind(
                    this
                  )}
                  canvasColorPicker={this.canvasColorPicker.bind(this)}
                />
              </div>
            </div>
          </div>
        </div>
        <button
          id="openModal"
          type="button"
          data-toggle="modal"
          data-target="#save_modal"
          style={{ display: "none" }}
        >
          Open Modal
        </button>

        <div className="modal fade" id="save_modal" role="dialog">
          <div className="modal-dialog">
            <div className="modal-header">
              <button type="button" className="close"  data-dismiss="modal">
                &times;
              </button>
             
            </div>
            <div className="modal-content">
              <div className="modal-body">
                <div className="havnot_picker_popup">
                  <div className="have_not_box">
                    <img src="https://animationish-staging-images.s3.amazonaws.com/havent_saved_background.png" />
                    <div className="project_file_save">
                      <h2>Project Name</h2>
                    </div>
                    <div className="saved_save_popup">
                      <div className="type_name">
                        <img src="https://animationish-staging-images.s3.amazonaws.com/input_background.png" alt="image" />
                        <div className="typing_input_name">
                          <input
                            type="text"
                            inputmode="text"
                            name="name"
                            placeholder="File Name"
                            ref="projectName"
                            onChange={(e) =>{
                              e.preventDefault();
                              this.setState({ blankProjectName: "" });
                            }}
                          />
                          <p className="errorMsg blankProjectName">
                            {this.state.blankProjectName}
                          </p>
                        </div>
                      </div>
                      <div className="yes_save">
                        <img
                          src="https://animationish-staging-images.s3.amazonaws.com/yes_sve.png"
                          onClick={(e) => this.saveFromModal(e)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ColorPickerModal
          handleColorPicker={this.handleColorPicker.bind(this)}
          selectedBrushColor={selectedBrushColor}
        />
        <UnsavedChangesModal
          noAndProceedBtn={this.noAndProceedBtn.bind(this)}
          saveBtnInUnsavedChangesModal={this.saveBtnInUnsavedChangesModal.bind(
            this
          )}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  canvas: state.canvas,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  loadExistingProjectFile: bindActionCreators(
    loadExistingProjectFile,
    dispatch
  ),
  newKeyframe: bindActionCreators(newKeyframe, dispatch),
  updateKeyframe: bindActionCreators(updateKeyframe, dispatch),
  setProjectType: bindActionCreators(setProjectType, dispatch),
  swal: bindActionCreators(swal.showAlert, dispatch),
  hideLoader: bindActionCreators(hideLoader, dispatch),
  showLoader: bindActionCreators(showLoader, dispatch),
  undoKeyframe: bindActionCreators(undoKeyframe, dispatch),
  deleteKeyframe: bindActionCreators(deleteKeyframe, dispatch),
  generateVideo: bindActionCreators(generateVideo, dispatch),
  createNewProject: bindActionCreators(createNewProject, dispatch),
  updateProject: bindActionCreators(updateProject, dispatch),
  getProjectDetailsById: bindActionCreators(getProjectDetailsById, dispatch),
  purgeCanvas: bindActionCreators(purgeCanvas, dispatch),
});

let wiggleDoodle = hotkeys(WiggleDoodle);

export default connect(mapStateToProps, mapDispatchToProps)(wiggleDoodle);
